import SharedItemRedirect from './views/SharedItemRedirect.vue';

const routes = [
  {
    path: '/shared/:data',
    name: 'shared-item',
    component: SharedItemRedirect,
    meta: {
      requiresAuth: false, // Public route - no authentication required
      title: 'Ouverture du lien...'
    }
  }
];
// /shared/eyJ0IjoiZCIsImlkIjoiaXl3aGgifQ==
export default routes;
